import { render, staticRenderFns } from "./NewPersonHomeWork.vue?vue&type=template&id=7032681b&scoped=true&"
import script from "./NewPersonHomeWork.vue?vue&type=script&lang=js&"
export * from "./NewPersonHomeWork.vue?vue&type=script&lang=js&"
import style0 from "./NewPersonHomeWork.vue?vue&type=style&index=0&id=7032681b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032681b",
  null
  
)

export default component.exports